import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LoginService} from '@services/login/login.service';

@Injectable({providedIn: 'root'})
export class UserService {
  private login = inject(LoginService);
  private router = inject(Router);
  readonly userObservable$ = this.login.user$;
  setUser(_: any) {}
  logout() { this.login.logoutUser(); this.router.navigate(['/login']); }
}
